<div
  class="plan border tw-relative tw-my-3 bg-white tw-flex tw-justify-between tw-items-center flex-column"
>
  <div class="tw-w-full">
    <h1
      class="tw-mt-[35px] tw-mb-4 tw-pb-5 border-bottom tw-text-gray-700 dark:tw-text-gray-200 tw-font-semibold tw-text-[16px] tw-mx-4"
    >
      {{ model?.name }}
    </h1>

    <!-- isActive -->
    <div
      *ngIf="model.isActive"
      class="tw-mt-[20px] tw-absolute"
      style="top: 5px; left: 15px"
    >
      <span
        class="border text-success border-success tw-px-2 tw-font-bold rounded-2 tw-block tw-ml-[3px] ltr:tw-mr-[3px] tw-text-[14px]"
        style="transform: rotate(332deg)"
        >{{ "common.isActive" | translate }}</span
      >
    </div>

    <!-- price -->
    <div class="tw-flex-center">
      <div class="tw-relative">
        <div class="tw-font-semibold tw-text-[28px] text-navyBlue">
          {{ model?.price | numberSeparator }}
        </div>
      </div>
      <small
        class="tw-text-[14px] tw-font-semibold tw-mr-[5px] ltr:tw-ml-[5px] text-navyBlue tw-mt-2"
        >{{ "common.currency" | translate }}</small
      >
    </div>

    <div class="tw-flex-center tw-mt-4">
      <ul class="tw-px-3 tw-mx-5 tw-w-full">
        <!-- expirationTime -->
        <li
          class="tw-flex tw-justify-between tw-items-center tw-py-1 tw-my-1 border-bottom"
        >
          <span
            class="tw-text-gray-600 tw-font-normal text-md tw-mx-2 tw-my-2 tw-text-[13px]"
            >{{ "common.expireDate" | translate }}
          </span>
          <b
            class="tw-font-medium tw-px-1 tw-text-gray-800 tw-text-[14px] dir-ltr"
            >{{
              model?.expirationTime
                | dateTimeConvertor : translationService.currentLang()
            }}</b
          >
        </li>
      </ul>
    </div>
  </div>
  <ng-container>
    <div (click)="onEmitSelectedPlanListItemPrice()" class="tw-mb-[30px]">
      <a
        class="btn tw-text-[16px] tw-font-medium tw-h-[45px] tw-flex-center border border-blue btn-light-blue tw-w-[150px] btn-hover-rise"
        style="border-color: unset !important"
      >
        <ng-container *ngIf="!buyButtonLoading" class="tw-px-1">
          <i class="mdi mdi-22px mdi-shopping"></i>
          <span> {{ "common.buy" | translate }}</span>
        </ng-container>

        <!-- loading -->
        <ng-container *ngIf="buyButtonLoading" class="tw-px-1">
          <div class="tw-px-1 tw-flex-center">
            <span
              class="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span class="sr-only">Loading...</span>
          </div>
        </ng-container>
      </a>
    </div>
  </ng-container>
  <!-- <ng-container *ngIf="model.isActive">
  <a class="tw-text-[16px] tw-font-medium tw-h-[45px] tw-flex-center border border-success bg-success tw-w-[150px] tw-mb-[30px]" style="border-radius: 0.475rem;">
    <span class="text-white"> {{"common.isActive"|translate}}</span>
    </a>
</ng-container> -->
</div>
